import theme from '../theme';

const responseColor = (status: string) => {
  const responseColors: {[key: string]: string} = theme.status.response;
  return responseColors[status];
};

export default responseColor;
